import { AgentBase } from '../bases/agent';
import {
  initConfiguration as configure,
  getConfigurationValue,
  isEnabled,
} from '../state/init';
import { setInitializedAgent } from '../window/browser';
import { loaderPriority } from './constants';
import { Instrument as SignalTraces } from '../signals/traces';
import { Instrument as SignalMetrics } from '../signals/metrics';
import { Instrument as InstrumentSessionReplay } from '../features/session_replay';
import { Instrument as InstrumentDomCapture } from '../features/dom_capture';
import { Instrument as InstrumentWebVitals } from '../features/web_vitals';
import { Instrument as InstrumentResourceTiming } from '../features/resource_timing';
import { Instrument as InstrumentSessionTrace } from '../features/session_trace';
import { Instrument as InstrumentHeaviestResources } from '../features/heaviest_resources';
import { Instrument as InstrumentFailedLoadResources } from '../features/failed_load_resources';
import { Instrument as SignalsSpans } from '../signals/spans';
import { Instrument as SignalsLogs } from '../signals/logs';
import { Harvester } from './harvester';
import { registerServiceWorker } from '../worker';

export const availableInstruments = [
  InstrumentWebVitals,
  InstrumentResourceTiming,
  InstrumentSessionReplay,
  InstrumentSessionTrace,
  InstrumentHeaviestResources,
  InstrumentFailedLoadResources,
  InstrumentDomCapture,
];

export const signals = [SignalTraces, SignalMetrics, SignalsSpans, SignalsLogs];

export class Agent extends AgentBase {
  constructor() {
    super();
    this.instruments = {};

    setInitializedAgent();
    configure(this);

    this.start();
  }

  start() {
    this.initHarvester();
    this.initFeatures();

    return true;
  }

  initFeatures() {
    const instrumentsToStart = availableInstruments.filter((feature) =>
      isEnabled(feature.featureName),
    );

    signals.sort(
      (a, b) => loaderPriority[a.featureName] - loaderPriority[b.featureName],
    );

    signals.forEach((Signal) => {
      this.instruments[Signal.featureName] = new Signal();

      if (
        getConfigurationValue(
          `instruments.signals.${Signal.featureName}.harvester`,
        )
      ) {
        this.harverster.subscribe(
          this.instruments[Signal.featureName].getAggregator(),
        );
      }
    });

    instrumentsToStart.sort(
      (a, b) => loaderPriority[a.featureName] - loaderPriority[b.featureName],
    );

    instrumentsToStart.forEach((Instrument) => {
      this.instruments[Instrument.featureName] = new Instrument();

      if (
        getConfigurationValue(
          `instruments.features.${Instrument.featureName}.harvester`,
        )
      ) {
        this.harverster.subscribe(
          this.instruments[Instrument.featureName].getAggregator(),
        );
      }
    });
  }

  initHarvester() {
    this.harverster = new Harvester(this.config.harvester);
  }

  registerWorker() {
    registerServiceWorker({
      url: getConfigurationValue('service_worker_url'),
      scope: '/wm-agent/v1/',
      onSuccess: (registration) => {
        console.log(
          `Service Worker registrado con scope: ${registration.scope}`,
        );
      },
      onError: (error) => {
        console.error('Error al registrar el Service Worker:', error);
      },
    })
      .then(() => {})
      .catch(() => {});
  }
}
